<script>
    import Template from '{Template}/Web/Pages/Dashboard.template'
    import AppLayout from '@/Layouts/AppLayout'
    import Welcome from '@/Jetstream/Welcome'
    import LanguageSwitcher from '@/Components/LanguageSwitcher'
    import MarketMixin from "@/Mixins/Market/MarketMixin";
    import { Hooper, Slide } from 'hooper';
    import 'hooper/dist/hooper.css';

    export default Template({
        components: {
            AppLayout,
            Welcome,
            LanguageSwitcher,
            Hooper,
            Slide
        },
        data() {

            return {
		email: this.getCookie('userEmail') || '',		
                sliderElements: 4,
                isMobile: false,
                hooperSettings: {
                    itemsToShow: 4,
                    vertical: false,
                    autoPlay: true,
                    touchDrag: true,
                    mouseDrag: true,
                    playSpeed: 3000,
                    infiniteScroll: true,
                    breakpoints: {
                        270: {
                            itemsToShow: 1,
                        },
                        700: {
                            itemsToShow: 3,
                        },
                        900: {
                            itemsToShow: 3,
                        },
                    }
                }
            }
        },
        props: {
            articles: Object,
        },
        created() {
            window.addEventListener("resize", this.sliderListener);
        },
        destroyed() {
            window.removeEventListener("resize", this.sliderListener);
        },
        methods: {

	    saveEmail() {
      this.setCookie('userEmail', this.email, 365);
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    setCookie(name, value, days) {
      const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `${name}=${value}; expires=${expires}; path=/`;
    },

            sliderListener() {
                if(window.innerWidth >= 670) {
                    this.sliderElements = 3;
                    this.isMobile = false;
                } else {
                    this.sliderElements = 2;
                    this.isMobile = false;
                }
            },
            setArticle(article) {
                this.$inertia.visit(route('article', article.id));
            },
        },
        computed: {
            sliderMarkets: function () {

                let markets = this.$store.getters.getMarkets;

                if(markets && markets.length) {
                    return _.chunk(_.orderBy(markets, (market) => {
                        return parseFloat(market['name']);
                    }, 'desc'), this.sliderElements);
		   
                }
	    },

               topMarkets: function () {
                 let markets = this.$store.getters.getMarkets;

                  if (markets && markets.length) {
                  // Sort the markets array by the criteria you want (e.g., volume)
                      const sortedMarkets = _.orderBy(markets, (market) => {
                  return parseFloat(market['volume']);
                }, 'desc');

                 // Slice the sorted array to get only the top five markets
                  return sortedMarkets.slice(0, 5);
                }
                 // If there are no markets, return an empty array or handle it as needed
                return [];
             },

	       gainMarkets: function () {
                 let markets = this.$store.getters.getMarkets;

                  if (markets && markets.length) {
                  // Sort the markets array by the criteria you want (e.g., volume)
                      const sortedMarkets = _.orderBy(markets, (market) => {
                  return parseFloat(market['change']);
                }, 'desc');

                 // Slice the sorted array to get only the top five markets
                  return sortedMarkets.slice(0, 5);
                }
                 // If there are no markets, return an empty array or handle it as needed
                return [];
             },

	      btcMarkets: function () {
                 let markets = this.$store.getters.getMarkets;

                  if (markets && markets.length) {
                  // Sort the markets array by the criteria you want (e.g., volume)
                      const sortedMarkets = _.orderBy(markets, (market) => {
                  return parseFloat(market['id']);
                }, 'asc');

                 // Slice the sorted array to get only the top five markets
                  return sortedMarkets.slice(0, 5);
                }
                 // If there are no markets, return an empty array or handle it as needed
                return [];
             },

		newMarkets: function () {
                 let markets = this.$store.getters.getMarkets;

                  if (markets && markets.length) {
                  // Sort the markets array by the criteria you want (e.g., volume)
                      const sortedMarkets = _.orderBy(markets, (market) => {
                  return parseFloat(market['date']);
                }, 'desc');

                 // Slice the sorted array to get only the top five markets
                  return sortedMarkets.slice(0, 5);
                }
                 // If there are no markets, return an empty array or handle it as needed
                return [];
             }
	       
                

        },
        mixins: [MarketMixin],
        mounted() {
		this.email = this.getCookie('userEmail') || '';
            //this.sliderListener();

            if(_.isEmpty(this.markets)) {
                this.$store.dispatch('fetchMarkets');
            }

            if(!this.$page.props.alt) {
                window.TyperSetup();
            }
        }
    });
</script>
